import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Colors } from '../../../shared/enums/shared.enums';
import ViewportType from '../../../shared/enums/viewport-type.enums';
import { ImageComponent } from '../../atoms/image/image.component';
import { CaasComponent } from '../../../shared/interfaces/caas/caas.interface';
import { ImagesService } from '../../../services/images.service';

@Component({
  selector: 'hdi-static-graphic',
  standalone: true,
  imports: [CommonModule, ImageComponent],
  templateUrl: './static-graphic.component.html',
  styleUrls: ['./static-graphic.component.scss'],
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class StaticGraphicComponent implements OnChanges {
  @Input() src: string | string[] = '';
  @Input() alt: string = '';
  @Input() title: string = '';
  @Input() headline?: string;
  @Input() viewport: ViewportType = ViewportType.desktop;
  @Input() backgroundColor?: Colors;
  @Input() caasData?: CaasComponent;

  desktopImageSrc: string = '';
  mobileImageSrc: string = '';

  constructor(private imagesService: ImagesService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['caasData']) {
      // Set desktop and mobile image sources
      this.desktopImageSrc =
        this.caasData?.formData?.st_image?.value?.url ?? '';
      this.mobileImageSrc =
        this.caasData?.formData?.st_image_mobile?.value?.url ||
        this.desktopImageSrc;
      // Set the headline, alt text, and title
      this.headline = this.caasData?.formData?.st_header?.value ?? '';
      if (this.caasData?.formData?.st_image?.value?.identifier) {
        this.alt =
          this.imagesService.getAltTextById(
            this.caasData.formData.st_image.value.identifier
          ) ?? '';
      }
      if (this.caasData?.formData?.st_image_title?.value) {
        this.title = this.caasData.formData.st_image_title.value;
      }
    }
  }

  isTransparent(): boolean {
    return this.backgroundColor === undefined;
  }

  isArrayOfImages(): boolean {
    return Array.isArray(this.src);
  }

  getImageSources(): string[] {
    return Array.isArray(this.src) ? this.src : [this.src];
  }
}
